<template>
  <div>
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t('general.add')}}
        </el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('empIns4.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date | formatDate }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empIns4.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empIns4.gender')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.gender }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empIns4.shutoku_kuben_code')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.shutoku_kuben_code}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empIns4.profession_type_code')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.profession_type_code}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empIns4.nation')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.nation}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t('general.edit')}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t('general.delete')}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t('general.print')}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Add -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="77%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="240px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition">
        <el-input type="hidden" v-model="ruleForm.id" />

        <el-collapse accordion>
          <el-collapse-item :title="$t('empIns4.basic1')" name="1" class="title" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empIns4.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id" clearable style="margin-left:10px;width: 185px"
                      size="mini" @change="employeeIdSelected" :placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.name')" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.name')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.change_name')" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.change_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.change_name')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.gender')" prop="gender" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.gender" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.gender')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.nation')" prop="nation" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.nation" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.nation')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.resident')" prop="nation" style="margin-left:50px"
                    v-if="ruleForm.nation !== 'JPN-日本'">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.resident" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.resident')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.remark')" prop="remark" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.remark" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.remark')"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item><br></el-form-item>
                  <el-form-item :label="$t('empIns4.name_frgn')" prop="name_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name_frgn" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.name_frgn')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.change_name_frgn')" prop="name_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.change_name_frgn" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.change_name_frgn')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.birthday')" prop="birthday" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.birthday" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.birthday')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.mynum')" prop="mynum" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.mynum" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.mynum')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.period_of_stay')" prop="" style="margin-left:50px"
                    v-if="ruleForm.nation !== 'JPN-日本'">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.resident_date" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.period_of_stay')" readonly>
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.working_category')" prop="working_category" style="margin-left:50px"
                    v-if="ruleForm.nation !== 'JPN-日本'">
                    <el-select v-model="ruleForm.working_category" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in working_category" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empIns4.basic2')" name="2" class="title" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empIns4.date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empIns4.date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.shutoku_kuben_code')" prop="shutoku_kuben_code"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.shutoku_kuben_code" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in shutoku_kuben" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.salary_type_code')" prop="salary_type_code"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.salary_type_code" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in salary_type" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.employment_type_code')" prop="employment_type_code"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.employment_type_code" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in employment_type" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.inaugural_type_code')" prop="inaugural_type_code"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.inaugural_type_code" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in inaugural_type" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.contract_type')" prop="contract_type" style="margin-left:50px">
                    <el-select v-model="ruleForm.contract_type" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in exist" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.contract_start_date')" prop="date" style="margin-left:50px"
                    v-if="ruleForm.contract_type === '有'">
                    <el-date-picker v-model="ruleForm.contract_start_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 130px" type="date" :placeholder="$t('empIns4.from')">
                    </el-date-picker>～
                    <el-date-picker v-model="ruleForm.contract_end_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:0px;width: 130px" type="date" :placeholder="$t('empIns4.to')">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empIns4.shutoku_date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.shutoku_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empIns4.shutoku_date')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('empIns4.genin_code')" prop="genin_code" style="margin-left:50px">
                    <el-select v-model="ruleForm.genin_code" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in genin" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.salary_amount')" prop="salary_amount" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.salary_amount" size="mini"
                      style="margin-left:10px;width: 150px" :placeholder="$t('empIns4.salary_amount')"></el-input>
                    {{$t("empIns4.thousand")}}
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.profession_type_code')" prop="profession_type_code"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.profession_type_code" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in profession_type" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.week_work_time')" prop="week_work_time" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.week_work_hour" size="mini"
                      style="margin-left:10px;width: 70px" :placeholder="$t('empIns4.hour')"></el-input>
                    {{$t("empIns4.hour")}}
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.week_work_min" size="mini"
                      style="margin-left:10px;width: 70px" :placeholder="$t('empIns4.minute')"></el-input>
                    {{$t("empIns4.minute")}}
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.contract_update_type_code')" prop="contract_update_type_code"
                    style="margin-left:50px" v-if="ruleForm.contract_type === '有'">
                    <el-select v-model="ruleForm.contract_update_type_code" :placeholder="$t('general.select')"
                      clearable size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in exist" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}} </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!-- Edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="77%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="240px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition">
        <el-input type="hidden" v-model="ruleForm.id" />

        <el-collapse accordion>
          <el-collapse-item :title="$t('empIns4.basic1')" name="1" class="title" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empIns4.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id" clearable style="margin-left:10px;width: 185px"
                      size="mini" @change="employeeIdSelected" :placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.name')" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.name')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.change_name')" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.change_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.change_name')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.gender')" prop="gender" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.gender" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.gender')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.nation')" prop="nation" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.nation" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.nation')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.resident')" prop="nation" style="margin-left:50px"
                    v-if="ruleForm.nation !== 'JPN-日本'">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.resident" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.resident')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.remark')" prop="remark" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.remark" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.remark')"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item><br></el-form-item>
                  <el-form-item :label="$t('empIns4.name_frgn')" prop="name_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name_frgn" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.name_frgn')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.change_name_frgn')" prop="name_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.change_name_frgn" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.change_name_frgn')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.birthday')" prop="birthday" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.birthday" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.birthday')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.mynum')" prop="mynum" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.mynum" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.mynum')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.period_of_stay')" prop="" style="margin-left:50px"
                    v-if="ruleForm.nation !== 'JPN-日本'">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.resident_date" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns4.period_of_stay')" readonly>
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.working_category')" prop="working_category" style="margin-left:50px"
                    v-if="ruleForm.nation !== 'JPN-日本'">
                    <el-select v-model="ruleForm.working_category" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in working_category" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('empIns4.basic2')" name="2" class="title" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empIns4.date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empIns4.date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.shutoku_kuben_code')" prop="shutoku_kuben_code"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.shutoku_kuben_code" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in shutoku_kuben" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.salary_type_code')" prop="salary_type_code"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.salary_type_code" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in salary_type" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.employment_type_code')" prop="employment_type_code"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.employment_type_code" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in employment_type" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.inaugural_type_code')" prop="inaugural_type_code"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.inaugural_type_code" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in inaugural_type" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.contract_type')" prop="contract_type" style="margin-left:50px">
                    <el-select v-model="ruleForm.contract_type" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in exist" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.contract_start_date')" prop="date" style="margin-left:50px"
                    v-if="ruleForm.contract_type === '有'">
                    <el-date-picker v-model="ruleForm.contract_start_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 130px" type="date" :placeholder="$t('empIns4.from')">
                    </el-date-picker>～
                    <el-date-picker v-model="ruleForm.contract_end_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:0px;width: 130px" type="date" :placeholder="$t('empIns4.to')">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empIns4.shutoku_date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.shutoku_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empIns4.shutoku_date')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('empIns4.genin_code')" prop="genin_code" style="margin-left:50px">
                    <el-select v-model="ruleForm.genin_code" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in genin" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.salary_amount')" prop="salary_amount" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.salary_amount" size="mini"
                      style="margin-left:10px;width: 150px" :placeholder="$t('empIns4.salary_amount')"></el-input>
                    {{$t("empIns4.thousand")}}
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.profession_type_code')" prop="profession_type_code"
                    style="margin-left:50px">
                    <el-select v-model="ruleForm.profession_type_code" :placeholder="$t('general.select')" clearable
                      size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in profession_type" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.week_work_time')" prop="week_work_time" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.week_work_hour" size="mini"
                      style="margin-left:10px;width: 70px" :placeholder="$t('empIns4.hour')"></el-input>
                    {{$t("empIns4.hour")}}
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.week_work_min" size="mini"
                      style="margin-left:10px;width: 70px" :placeholder="$t('empIns4.minute')"></el-input>
                    {{$t("empIns4.minute")}}
                  </el-form-item>

                  <el-form-item :label="$t('empIns4.contract_update_type_code')" prop="contract_update_type_code"
                    style="margin-left:50px" v-if="ruleForm.contract_type === '有'">
                    <el-select v-model="ruleForm.contract_update_type_code" :placeholder="$t('general.select')"
                      clearable size="mini" style="margin-left:10px;width: 185px">
                      <el-option v-for="item in exist" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <div style="text-align: left; margin-top: 4vh; font-size: smaller; width: fit-content; ">
      <el-card style="background-color: #51d1ff1c;">
        お願い
        <ol>
          <li>
            雇用保険の資格取得年月日の属する月の翌月10日までに提出してください。
          </li>
          <li>
            賃金台帳、労働者名簿、出勤簿その他記載内容を確認できる書類を持参していただく場合があります。
          </li>
          <li>
            被保険者が法人の取締役又は事業主と同居の親族の場合は、事業所名欄右の備考欄にその旨記載してください。
          </li>
        </ol>
      </el-card>
    </div>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        value: "",
        empList: [{
          id: "",
          employee_id: "",
          name: "",
          name_frgn: "",
          name_frgn: "",
          mynum: "",
          gender: "",
          birthday: "",
          nation: "",
          resident: "",
        },],
        empList1: [],
        ruleForm: {
          id: "",
          shutoku_kuben_code: "",
          change_name: "",
          change_name_frgn: "",
          genin_code: "",
          salary_type_code: "",
          salary_amount: "",
          shutoku_date: "",
          employment_type_code: "",
          profession_type_code: "",
          inaugural_type_code: "",
          week_work_hour: "00",
          week_work_min: "00",
          contract_type: "",
          contract_start_date: "",
          contract_end_date: "",
          contract_update_type_code: "",
          remark: "",

          working_category: "",
          date: "",
          employee_id: "",

          name: "",
          name_frgn: "",
          name_frgn: "",
          mynum: "",
          gender: "",
          birthday: "",
          nation: "",
          resident: "",
        },
        shutoku_kuben: [{
          value: "新規",
          label: this.$t("empIns4.new"),
        },
        {
          value: "再取得",
          label: this.$t("empIns4.reacquire"),
        }
        ],
        genin: [{
          value: "新規雇用（新規学卒）",
          label: this.$t("empIns4.new_graduate"),
        },
        {
          value: "新規雇用（その他）",
          label: this.$t("empIns4.new_other"),
        },
        {
          value: "日雇からの切替",
          label: this.$t("empIns4.from_daily"),
        },
        {
          value: "その他",
          label: this.$t("general.other"),
        },
        {
          value: "出向元への復帰等（65歳以上）",
          label: this.$t("empIns4.over60"),
        }
        ],
        salary_type: [{
          value: "月給",
          label: this.$t("empIns4.monthly"),
        },
        {
          value: "週給",
          label: this.$t("empIns4.weekly"),
        },
        {
          value: "日給",
          label: this.$t("empIns4.dailypay"),
        },
        {
          value: "時間給",
          label: this.$t("empIns4.hourly"),
        },
        {
          value: "その他",
          label: this.$t("general.other"),
        }
        ],
        employment_type: [{
          value: "日雇",
          label: this.$t("empIns4.daily"),
        },
        {
          value: "パートタイム",
          label: this.$t("empIns4.part_time"),
        },
        {
          value: "派遣",
          label: this.$t("empIns4.dispatch"),
        },
        {
          value: "有期契約労働者",
          label: this.$t("empIns4.contract_worker"),
        },
        {
          value: "季節的雇用",
          label: this.$t("empIns4.seasonal"),
        },
        {
          value: "船員",
          label: this.$t("empIns4.sailor"),
        },
        {
          value: "その他",
          label: this.$t("general.other"),
        }
        ],
        profession_type: [{
          value: "管理的職業",
          label: this.$t("empIns4.admin"),
        },
        {
          value: "専門的・技術的職業",
          label: this.$t("empIns4.technical"),
        },
        {
          value: "事務的職業",
          label: this.$t("empIns4.office"),
        },
        {
          value: "販売の職業",
          label: this.$t("empIns4.sale"),
        },
        {
          value: "サービスの職業",
          label: this.$t("empIns4.service"),
        },
        {
          value: "保安の職業",
          label: this.$t("empIns4.security"),
        },
        {
          value: "農林漁業の職業",
          label: this.$t("empIns4.agriculture"),
        },
        {
          value: "生産工程の職業",
          label: this.$t("empIns4.production"),
        },
        {
          value: "輸送・機械運転の職業",
          label: this.$t("empIns4.transportation"),
        },
        {
          value: "建設・採掘の職業",
          label: this.$t("empIns4.construction"),
        },
        {
          value: "運搬・清掃・包装等の職業",
          label: this.$t("empIns4.reacquire"),
        }
        ],
        inaugural_type: [{
          value: "安定所紹介",
          label: this.$t("empIns4.stable_company"),
        },
        {
          value: "自己就職",
          label: this.$t("empIns4.self_employment"),
        },
        {
          value: "民間紹介",
          label: this.$t("empIns4.private_sector"),
        },
        {
          value: "把握していない",
          label: this.$t("empIns4.not_grasp"),
        }
        ],
        exist: [{
          value: "有",
          label: this.$t("empIns4.exist"),
        },
        {
          value: "無",
          label: this.$t("empIns4.not_exist"),
        }
        ],
        working_category: [{
          value: "1. 派遣・請負労働者として主に当該事業所以外で就労する",
          label: this.$t("empIns4.one"),
        },
        {
          value: "2. 1に該当しない",
          label: this.$t("empIns4.two"),
        }
        ],
        rules: {
          date: [{
            required: true,
            message: this.$t("empIns4.fill"),
            trigger: "blur",
          },],
          shutoku_kuben_code: [{
            required: true,
            message: this.$t("empIns4.fill"),
            trigger: "blur",
          },],
        },
        tableData: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        dialogDetails: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false,
      };
    },
    methods: {
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open("/pdf/雇用保険被保険者資格取得届-" + row.name + row.date + ".pdf");
      },
      employeeIdSelected() {
        let postData = this.qs.stringify({
          employee_id: this.ruleForm.employee_id,
        });
        this.axios({
          method: "post",
          url: "/ListEmpList",
          data: postData,
        })
          .then((response) => {
            this.empList1 = response.data;
            this.emp = this.empList1[0];
            this.ruleForm.name = this.emp.name;
            this.ruleForm.name_frgn = this.emp.name_frgn;
            this.ruleForm.mynum = this.emp.mynum;
            this.ruleForm.gender = this.emp.gender;
            this.ruleForm.birthday = this.emp.birthday;
            this.ruleForm.nation = this.emp.nation;
            this.ruleForm.resident = this.emp.resident;
            this.ruleForm.resident_date = this.emp.resident_date;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id,
        });
        this.axios({
          method: "post",
          url: "/printInsurance",
          data: postData,
        })
          .then((response) => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed"),
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 300);
          })
          .catch((error) => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed"),
            });
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        })
          .then(_ => {
            this.emptyUserData();
            done();
          })
          .catch(_ => { });
      },
      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: "OK",
          cancelButtonText: this.$t("general.cancel"),
          type: "warning",
        })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id,
            });
            this.axios({
              method: "post",
              url: "/deleteEmplns4",
              data: postData,
            })
              .then((response) => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageEmpIns4")
                  .then((response) => {
                    this.tableData = response.data;
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled"),
            });
          });
      },
      handleCurrentChange() {

        let postData = this.qs.stringify({
          page: this.currentPage,
        });
        this.axios({
          method: "post",
          url: "/pageEmpIns4",
          data: postData,
        })
          .then((response) => {
            this.tableData = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },
      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          shutoku_kuben_code: "",
          change_name: "",
          change_name_frgn: "",
          genin_code: "",
          salary_type_code: "",
          salary_amount: "",
          shutoku_date: "",
          employment_type_code: "",
          profession_type_code: "",
          inaugural_type_code: "",
          week_work_hour: "00",
          week_work_min: "00",
          contract_type: "",
          contract_start_date: "",
          contract_end_date: "",
          contract_update_type_code: "",
          remark: "",
          working_category: "",
          date: "",
          employee_id: "",

          name: "",
          name_frgn: "",
          name_frgn: "",
          mynum: "",
          gender: "",
          birthday: "",
          nation: "",
        };
      },
      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              shutoku_kuben_code: this.ruleForm.shutoku_kuben_code,
              change_name: this.ruleForm.change_name,
              change_name_frgn: this.ruleForm.change_name_frgn,
              genin_code: this.ruleForm.genin_code,
              salary_type_code: this.ruleForm.salary_type_code,
              salary_amount: this.ruleForm.salary_amount,
              shutoku_date: this.ruleForm.shutoku_date,
              employment_type_code: this.ruleForm.employment_type_code,
              profession_type_code: this.ruleForm.profession_type_code,
              inaugural_type_code: this.ruleForm.inaugural_type_code,
              week_work_hour: this.ruleForm.week_work_hour,
              week_work_min: this.ruleForm.week_work_min,
              contract_type: this.ruleForm.contract_type,
              contract_start_date: this.ruleForm.contract_start_date,
              contract_end_date: this.ruleForm.contract_end_date,
              contract_update_type_code: this.ruleForm.contract_update_type_code,
              remark: this.ruleForm.remark,

              working_category: this.ruleForm.working_category,
              date: this.ruleForm.date,
              employee_id: this.ruleForm.employee_id,
            });
            this.axios({
              method: "post",
              url: "/insertEmplns4",
              data: postData,
            })
              .then((response) => {
                this.axios
                  .post("/pageEmpIns4")
                  .then((response) => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed"),
                    });
                  })
                  .catch((error) => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed"),
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              shutoku_kuben_code: this.ruleForm.shutoku_kuben_code,
              change_name: this.ruleForm.change_name,
              change_name_frgn: this.ruleForm.change_name_frgn,
              genin_code: this.ruleForm.genin_code,
              salary_type_code: this.ruleForm.salary_type_code,
              salary_amount: this.ruleForm.salary_amount,
              shutoku_date: this.ruleForm.shutoku_date,
              employment_type_code: this.ruleForm.employment_type_code,
              profession_type_code: this.ruleForm.profession_type_code,
              inaugural_type_code: this.ruleForm.inaugural_type_code,
              week_work_hour: this.ruleForm.week_work_hour,
              week_work_min: this.ruleForm.week_work_min,
              contract_type: this.ruleForm.contract_type,
              contract_start_date: this.ruleForm.contract_start_date,
              contract_end_date: this.ruleForm.contract_end_date,
              contract_update_type_code: this.ruleForm.contract_update_type_code,
              remark: this.ruleForm.remark,

              working_category: this.ruleForm.working_category,
              date: this.ruleForm.date,
              employee_id: this.ruleForm.employee_id,
            });
            this.axios({
              method: "post",
              url: "/updateEmplns4",
              data: postData,
            })
              .then((response) => {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed"),
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      getPages() {
        this.axios
          .post("/rowsEmpIns4")
          .then((response) => {
            this.total = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      },
    },
    created() {
      this.axios
        .post("/pageEmpIns4")
        .then((response) => {
          this.show = true;
          this.tableData = response.data;
        })
        .catch((error) => {
          // this.show = false;
          // this.$message({
          //   type: 'error',
          //   message: '開発中です。'
          // });

        });

      this.axios
        .post("/rowsEmpIns4")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios
        .post("/ListEmpListForInsNameChange")
        .then((response) => {
          // console.log(response.data);
          this.empList = response.data;
          // console.log(this.empList);
        })
        .catch((error) => {
          console.log(error);
        });
    },

  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpIns4.vue